import { HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ToastService } from '../services/toast.service';
import { SILENT_REQUEST } from '../data/http-context';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toast = inject(ToastService);

  return next(req).pipe(
    catchError(err => {
      if (req.context.get(SILENT_REQUEST)) return throwError(() => err);
      if (err.status === HttpStatusCode.Unauthorized) return throwError(() => err);
      const message: string =
        err.error?.message ?? err.error?.title ?? err.message ?? 'An unexpected error occurred.';
      toast.showError(message);
      return throwError(() => err);
    })
  );
};
